import React, { Component } from 'react';
import { ExpandButton as Button } from 'components/Styled';

class ExpandButton extends Component {
  render() {
    return (
      <Button size="small" className="border-buttonTheme-color" onClick={this.props.onClick}>
        <span className="buttonTheme-color">
          {this.props.expand ? '－' : '＋'}
        </span>
      </Button>
    );
  }
}

export default ExpandButton;
